import { defineMessages } from 'react-intl'

const messages = defineMessages({
  convertToBooking: {
    id: 'convert-to-booking',
    defaultMessage: 'Convert option into booking',
  },
  downloadInvoice: {
    id: 'download_invoice',
    defaultMessage: 'Download invoice',
  },
  downloadVoucher: {
    id: 'download_voucher',
    defaultMessage: 'Download voucher',
  },
  addExtras: {
    id: 'profile.booking.add_extras',
    defaultMessage: 'Add extras to my booking',
  },
  extrasDetails: {
    id: 'profile.booking.rental_extras',
    defaultMessage: 'Rental equipment, transfers...',
  },
  start: {
    id: 'Start',
    defaultMessage: 'Start',
  },
  end: {
    id: 'end',
    defaultMessage: 'End',
  },
  duration: {
    id: 'duration',
    defaultMessage: 'Duration',
  },
  guestsPlural: {
    id: 'guests.pluralized',
    defaultMessage: '{qty, plural, one {# guest } other {# guests }}',
  },
  nightsPlural: {
    id: 'nights.pluralized',
    defaultMessage: '{qty, plural, one {# night } other {# nights }}',
  },
  guests: {
    id: 'guests',
    defaultMessage: 'Guests',
  },
  numberOfGuests: {
    id: 'number_of_guests_label',
    defaultMessage: 'Number of Guests',
  },
  nights: {
    id: 'nights',
    defaultMessage: 'nights',
  },
  arrive: {
    id: 'arrive',
    defaultMessage: 'Arrive',
  },
  depart: {
    id: 'depart',
    defaultMessage: 'Depart',
  },
  cabin: {
    id: 'cabin',
    defaultMessage: 'Cabin',
  },
  bookingIncludes: {
    id: 'your_booking_includes',
    defaultMessage: 'Your booking includes',
  },
  totalPrice: {
    id: 'totalPrice',
    defaultMessage: 'Total price',
  },
  diverPlural: {
    id: 'diver.pluralized',
    defaultMessage: '{ qty, plural, one {# x diver } other {# x divers }}',
  },
  nonDiverPlural: {
    id: 'nonDiver.pluralized',
    defaultMessage:
      '{ qty, plural, one {# x non-diver} other {# x non-divers}}',
  },
  occupancy: {
    id: 'occupancy',
    defaultMessage: 'Occupancy',
  },
  extras: {
    id: 'extras',
    defaultMessage: 'Extras',
  },
  mandatorySurcharges: {
    id: 'mandatory_surcharges',
    defaultMessage: 'Mandatory surcharges',
  },
  options: {
    id: 'options',
    defaultMessage: 'Options',
  },
  discount: {
    id: 'discount',
    defaultMessage: 'Discount',
  },
  totalPriceForMandatory: {
    id: 'booking_info.total_price_mandatory',
    defaultMessage: 'Total price for mandatory surcharges',
  },
  totalPriceForExtras: {
    id: 'booking_info.total_price_extras',
    defaultMessage: 'Total price for extras',
  },
  totalPriceForOptions: {
    id: 'booking_info.total_price_options',
    defaultMessage: 'Total price for options',
  },
  totalPriceForDiscounts: {
    id: 'booking_info.total_price_discounts',
    defaultMessage: 'Total price for discounts',
  },
})

export default messages
